import type { Client } from '../api/types';
import { eL } from '../utils/format';
import { verHistorial } from '../store/actions/visit.actions';

export function ClientCard({ c, showState = true }: { c: Client; showState?: boolean }) {
  return (
    <div
      class="card"
      style={
        showState
          ? { cursor: 'pointer', borderLeft: '3px solid var(' + (c.estado === 'vencida' ? '--danger' : '--warning') + ')' }
          : { cursor: 'pointer' }
      }
      onClick={() => verHistorial(c.id)}
    >
      <div class="row">
        <strong>{c.nombre}</strong>
        <span class={'badge ' + c.estado}>
          {showState
            ? c.diasRestantes !== null && c.diasRestantes >= 0
              ? c.diasRestantes + 'd'
              : Math.abs(c.diasRestantes ?? 0) + 'd atraso'
            : eL(c.estado)}
        </span>
      </div>
      {showState ? (
        c.zona && <p class="muted">Zona: {c.zona}</p>
      ) : (
        <>
          <p class="muted">
            {c.direccion || ''}
            {c.zona ? ' · Zona: ' + c.zona : ''}
          </p>
          <p class="muted">
            {c.visitasMensuales} visita(s)/mes
            {c.diasRestantes !== null
              ? c.diasRestantes >= 0
                ? ' · ' + c.diasRestantes + 'd restantes'
                : ' · ' + Math.abs(c.diasRestantes) + 'd atraso'
              : ''}
          </p>
        </>
      )}
    </div>
  );
}
